/** Editorial body generation is deliberately NOT sitemap-driven. */
export const PUBLIC_PILOT_PATHS = ["/climb", "/camp"] as const;
export type PublicPilotPath = (typeof PUBLIC_PILOT_PATHS)[number];
export const MAX_PUBLIC_PILOT_PAGES = 2;
export function isPublicPilotPath(pathname: string): pathname is PublicPilotPath {
  return PUBLIC_PILOT_PATHS.some((path) => path === pathname);
}
export function catalogBuildMode(args: readonly string[]): "offline" | "refresh" {
  return args.includes("--public-pilot-offline") ? "offline" : "refresh";
}